import React from "react";

import { Navigate, Link } from "react-router-dom";

import { UseAuth } from "../hooks/useAuth";

export default function LayoutDefault(props) {
  const { children } = props;
  const { user, isLoading } = UseAuth();

  if (user && !isLoading) {
    return <Navigate to="/" replace />;
  }


  return <div >{children}</div>;
}